import React from "react";
import PropTypes from "prop-types";

import StandardTable from "./StandardTable";
import SecondaryTable from "./SecondaryTable";
import GroupedTable from "./GroupedTable";
import ComponentMissing from "../../Debug/ComponentMissing";

const TableSwitcher = ({
  layout,
  header,
  headerType,
  headerDisplayStyle,
  headerLink,
  headerLinkType,
  secondaryLink,
  secondaryLinkType,
  subline,
  teaser,
  table,
  animation,
}) => {
  const properties = {
    header,
    headerType,
    headerDisplayStyle,
    headerLink,
    headerLinkType,
    secondaryLink,
    secondaryLinkType,
    subline,
    teaser,
    table,
    animation,
  };

  function switchTable() {
    switch (layout) {
      case 1:
        return <StandardTable properties={properties} />;
      case 3:
        return <SecondaryTable properties={properties} />;
      case 4:
        return <GroupedTable properties={properties} />;
      default:
        return <ComponentMissing type="Table" subType={layout} />;
    }
  }

  return switchTable();
};

TableSwitcher.propTypes = {
  layout: PropTypes.number,
  header: PropTypes.string,
  headerType: PropTypes.string,
  headerDisplayStyle: PropTypes.string,
  headerLinkType: PropTypes.string,
  secondaryLink: PropTypes.oneOfType([PropTypes.instanceOf(Object), PropTypes.string]),
  secondaryLinkType: PropTypes.string,
  subline: PropTypes.string,
  teaser: PropTypes.string,
  table: PropTypes.oneOfType([PropTypes.instanceOf(Array), PropTypes.string]),
  animation: PropTypes.instanceOf(Object),
};

export default TableSwitcher;
